<template>
  <div
    class="card"
    :class="customClass"
  >
    <div class="card-body p-2">
      <!-- <div class="float-right">
        <i class="fa fa-pen" />
      </div> -->
      <div
        class="text-muted"
        v-if="label!==''"
      >
        {{ label }}
      </div>
      <h5
        class="mb-1"
        v-if="text!==''"
        v-html="getText"
      />
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ReviewCardItem',
  props: {
    label: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    getText() {
      if (!this.text) return '';
      return this.text.replace(/(?:\r\n|\r|\n)/g, '<br />');
    },
  },
  methods: {
  },
};
</script>
<style scoped>
</style>
